import { Flex } from 'antd';
import styles from '../navbar.module.scss';
import UserStatusButton from '../../../utils/status/user_status_button';
import { FiveStarIcon, VerifiedIcon } from '../../../common/all-icons/custom-icons';

const StoriesSection = () => {
  const stories = [
    {
      title: 'Afterpay made it easy!',
      desc: 'They walked me through the process & explained in detail. I was struggling with my weight loss and Elevate has made it affordable by accepting Afterpay. I have been on the program for 12 weeks and am down ln 22 lbs. Never thought this would happen.',
      client: 'Kathy H.',
    },
    {
      title: 'Customer service on point',
      desc: 'Elevate has been amazing since day one. User friendly website. Very quick responses. And Joseph is the best! So friendly and helpful. The medication was delivered quick with easy instructions. They have helped me tremendously. So happy I found them!',
      client: 'Jane M.',
    },
    {
      title: 'Finally feel in control',
      desc: 'Excellent service! The meds have worked so well for me—with minimal side effects. I feel so much better and healthier overall. My appetite is way more manageable, and for the first time in a while, I feel like I actually have control over my routine.',
      client: 'Mary R.',
    },
  ];

  return (
    <div className={styles.signupSection}>
      <div className={styles.storySection}>
        <Flex vertical gap={12}>
          <Flex gap={8} vertical>
            <UserStatusButton status={"Don't just take our word for it"} color="primary" />
            <div className={styles.benefitsHeading}>These stories speak for themselves</div>
            <div style={{ color: 'var(--user-main-text)', textAlign: 'start' }} className={styles.boxDesc}>
              See what happens when support actually works
            </div>
          </Flex>
        </Flex>
        <div className={styles.trustWrap}>
          {stories.map((story, idx) => {
            return (
              <Flex key={idx} className={styles.storyBox} justify="center" align="center" vertical>
                <Flex vertical justify="center" align="center" gap={36}>
                  <Flex justify="center" align="center" gap={8}>
                    <VerifiedIcon />
                    <div className={'body-semibold'}>Verified Patient</div>
                  </Flex>
                  <Flex vertical justify="center" align="center" gap={12}>
                    <div className="h3-semibold text-align-center">{story?.title}</div>
                    <div className="h5-medium text-align-center">{story?.desc}</div>
                  </Flex>
                  <Flex vertical justify="center" align="center" gap={16}>
                    <FiveStarIcon />
                    <div className={'h5-semibold'}>{story?.client}</div>
                  </Flex>
                </Flex>
              </Flex>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StoriesSection;
